import { Sparkles } from 'lucide-react'

import { useStyles } from './styles'

const DEFAULT_SIZE = 28
const RADIUS_RATIO = 0.28
const GLYPH_RATIO = 0.55

type Props = {
  size?: number
  className?: string
}

export const SkalxAiIcon = ({ size = DEFAULT_SIZE, className }: Props) => {
  const { styles, cx } = useStyles()

  return (
    <span
      className={cx(styles.root, className)}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * RADIUS_RATIO)
      }}
      aria-hidden="true"
    >
      <Sparkles size={Math.round(size * GLYPH_RATIO)} strokeWidth={1.75} />
    </span>
  )
}
